import React from 'react'

import { StyledBadge, StyledBadgeIcon } from './HeaderWorkspaceBadge.styles'
import { PublicWorkspaceFragment } from 'gqlTypes'
import { isPersonalWorkspace } from 'modules/workspace/utils'

export interface HeaderWorkspaceBadgeProps {
  workspace: PublicWorkspaceFragment
  setSidebarLeftOpen?: React.Dispatch<React.SetStateAction<boolean>>
}

const HeaderWorkspaceBadge: React.FC<HeaderWorkspaceBadgeProps> = ({
  workspace,
  setSidebarLeftOpen,
}) =>
  isPersonalWorkspace(workspace) ? (
    <StyledBadgeIcon
      onClick={() => setSidebarLeftOpen?.(true)}
      icon="briefcase"
      size="24px"
    />
  ) : (
    <StyledBadge
      workspaceName={workspace.name}
      onClick={() => setSidebarLeftOpen?.(true)}
      src={workspace.avatar?.large}
      size="24px"
    />
  )
export default HeaderWorkspaceBadge
